import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { AccessControlService } from '../../services/access-control.service';
import { SubscriptionInfoModel } from 'src/app/models/subscription-info.model';
import { SubscriptionService } from '../../services/subscription.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PremiumSamplePopupComponent } from '../premium-sample-popup/premium-sample-popup.component';
import { AnalyticsUtils } from '../../services/analytics-utils';
import { ConditionalRenderingService } from '../../services/conditional-rendering.service';

@Component({
    selector: 'app-ipo-data-lock',
    templateUrl: './ipo-data-lock.component.html',
    styleUrls: ['./ipo-data-lock.component.scss'],
    standalone: false
})
export class IpoDataLockComponent implements OnInit {
   @Input() heading: string = '';
   @Input() companyProfile?: any = null;
   userRole: string | null = null;
   sampleModalRef: any;
   @Output() viewSampleClicked = new EventEmitter<void>();
   private subscriptions: Subscription[] = [];
   constructor(
      public accessControlService: AccessControlService,
      private modalService: NgbModal,
      private analyticsUtils: AnalyticsUtils,
      private conditionalRenderingService: ConditionalRenderingService
   ) {}

   ngOnInit(): void {
      console.log("   @Input() companyProfile?: any = null;",this.companyProfile)
      this.subscriptions.push(
         SubscriptionService.subscriptionData.subscribe(
            (data: SubscriptionInfoModel) => {
               this.userRole = data.role;
            }
         )
      );
   }

   viewSample() {
   if (this.heading === 'Shariah Compliance Report') {
      this.analyticsUtils.sample_shariah_report_tapped();
   }
   if (this.heading === 'Stock Forecast') {
      this.analyticsUtils.sample_forecast_tapped();
   }
   if (this.heading === 'Investment Checklist') {
      this.analyticsUtils.sample_investment_checklist_tapped();
   }

   // Remove this line or make it conditional:
   // this.conditionalRenderingService.setComponentType('ipo');

   if (this.heading === 'Shariah Compliance Report') {
      this.openReportSample();
   } else {
      // Only set to 'ipo' for non-report cases
      this.conditionalRenderingService.setComponentType('report');
      this.openSampleModal();
   }

   this.viewSampleClicked.emit();
}

openReportSample() {
   this.sampleModalRef = this.modalService.open(
      PremiumSamplePopupComponent,
      {
         centered: true,
         size: 'xl',
      }
   );

   // Pass the data to the modal component instance
   this.sampleModalRef.componentInstance.stockTicker = this.companyProfile?.ticker || 'AAPL';
   this.sampleModalRef.componentInstance.stockName = this.companyProfile?.name || 'Apple';

   // Set the component type after the modal is opened
   setTimeout(() => {
      this.conditionalRenderingService.setComponentType('report');
   }, 0);
}

openSampleModal() {
   this.sampleModalRef = this.modalService.open(
      PremiumSamplePopupComponent,
      {
         centered: true,
         size: 'lg',
      }
   );

   // Pass the data to the modal component instance for non-report cases too
   this.sampleModalRef.componentInstance.stockTicker = this.companyProfile?.ticker || 'AAPL';
   this.sampleModalRef.componentInstance.stockName = this.companyProfile?.name || 'Apple';
}
}
